export default __webpack_public_path__ + "static/media/3.fae33a41.webp";